import CampaignOpportunityDto from '@/models/CampaignOpportunities/CampaignOpportunityDto';

export default class CampaignOpportunitiesViewModel {
    selectedOpportunityId = '';
    selectedCampaignOpportunity: CampaignOpportunityDto | null = null;
    campaignOpportunities: CampaignOpportunityDto[] = [];
}
